import red from "@material-ui/core/colors/red";
import tccStyles from "../styles";

const ProductionTheme = {
    palette: {
        primary: {
            main: tccStyles.productionColor.primary,
            contrastText: "#fff"
        },
        secondary: {
            main: tccStyles.productionColor.secondary,
            contrastText: "#fff"
        },
        error: red,
        contrastThreshold: 3,
        tonalOffset: 0.2
    },
    typography: {
        // Use the system font instead of the default Roboto font.
        fontSize: "medium"
    },
    overrides: {
        MuiCard: {
            // override the styles of all instances of this component
            root: {
                // Name of the rule
                overflow: "visible" // Some CSS
            }
        }
    }
};

export default ProductionTheme;



// WEBPACK FOOTER //
// ./src/common/themes/productionTheme.js